"use strict";

require("core-js/modules/es6.array.for-each");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.map");

require("core-js/modules/es6.object.define-property");

function _interopDefault(e) {
  return e && "object" == typeof e && "default" in e ? e["default"] : e;
}

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var React = require("react"),
    React__default = _interopDefault(React),
    StateContext = React.createContext(),
    Provider = function Provider(e) {
  var t = e.stores,
      r = e.children,
      o = new Map();
  if (!t || !t.length) throw new Error("You must provide stores list to a <Provider> for initialization!");
  return t.forEach(function (e) {
    o.set(e, e());
  }), React__default.createElement(StateContext.Provider, {
    value: o
  }, r);
};

function useStore(e) {
  var t = React.useContext(StateContext);
  if (!t) throw new Error("You must wrap your components with a <Provider>!");
  var r = t.get(e);
  if (!r) throw new Error("Provided store instance did not initialized correctly!");
  return r;
}

exports.Provider = Provider, exports.useStore = useStore;